/**
 * Per-photographer accent colour helpers. The accent is scoped to the public
 * profile page root only (see design_guidelines.md > marketplace appendix);
 * LXRA gold stays on all global chrome and on the Verified badge.
 */
export const LXRA_GOLD_HEX = '#C9A45C';

export const hexToHsl = (hex) => {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || '');
  if (!m) return null;
  const n = parseInt(m[1], 16);
  const r = ((n >> 16) & 255) / 255;
  const g = ((n >> 8) & 255) / 255;
  const b = (n & 255) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let h = 0;
  let s = 0;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h *= 60;
  }
  return { h: Math.round(h), s: Math.round(s * 100), l: Math.round(l * 100) };
};

/**
 * Contrast guardrail: keep lightness between 38% and 70% so accents read on
 * the matte-black canvas without glare. Returns an `h s% l%` triplet string
 * usable inside `hsl(var(--studio-accent))`.
 */
export const clampedAccentHsl = (hex) => {
  const hsl = hexToHsl(hex) || hexToHsl(LXRA_GOLD_HEX);
  const l = Math.min(70, Math.max(38, hsl.l));
  return `${hsl.h} ${hsl.s}% ${l}%`;
};

export const accentStyle = (hex) => ({ '--studio-accent': clampedAccentHsl(hex) });

export const formatPriceFrom = (cents) => {
  if (cents == null) return null;
  return `$${Math.round(cents / 100).toLocaleString()}`;
};

export const formatDistance = (miles) => {
  if (miles == null) return null;
  if (miles < 1) return 'under 1 mi';
  return `${Math.round(miles)} mi`;
};
